import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDING_ID,
    appId: process.env.REACT_APP_APP_ID
}

export const app = initializeApp(firebaseConfig);

// Initialize Firestore with long-polling auto-detect so the app keeps working
// behind corporate VPNs, firewalls, and proxies that buffer or block the
// default WebChannel streaming transport. This must run before any
// getFirestore(app) call, which it does since this module is imported first.
export const db = initializeFirestore(app, {
    experimentalAutoDetectLongPolling: true,
});